<template>
  <div class="item flex-row flex__left margin-bottom-10">
    <div class="label font-size__small txt-right">
      <slot name="label"></slot>
    </div>
    <div class="content width__100 has-border__bottom">
      <slot name="value"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "readonly-form-item"
};
</script>

<style scoped>
.content {
  font-weight: 300 !important;
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/readonly-form-item.vue